import React from 'react';
import styled from 'styled-components';
import Constants from '../../submodules/logictry_config/constants';
import WindowSize from '../../services/WindowSize';
import Navigation from '../../services/Navigation';
import UserCache from '../../services/cache/UserCache';
import LogicBaseCollectionCache from '../../services/cache/LogicBaseCollectionCache';
import { SearchIcon } from '../../styledhtml/Icon';
import Popup from '../Popup';
import Scrollable from '../Scrollable';
import LogicBaseCollectionRow from '../LogicBaseCollectionRow';
import LogicBaseTab from '../LogicBaseTab';
import UserProfileHeader from '../UserProfileHeader';
import LoadingIndicator from '../LoadingIndicator';
import LogictryComponent from '../../submodules/logictry_config/LogictryComponent';

const Search = styled.div`
  width: 100%;
  max-width: 38rem;
  position: relative;
  overflow: hidden;
  margin: 0.5rem auto;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  cursor: text;
  border: ${Constants.LightBorder};
  ${Constants.MediaMobile} {
    border: unset;
  }
  > div:first-child {
    width: 100%;
    position: relative;
    background: white;
    color: #999;
  }
`;

const Wrapper = styled.div`
  ${Constants.PopupHeight}
  width: ${Constants.ListPopupWidth};
  max-width: 90vw;
  overflow: hidden;
  position: relative;
  h1 {
    text-align: center;
  }
  > div:last-child {
    padding: 1.5rem 0 2rem;
    width: 100%;
  }
  input {
    border-radius: 0;
    padding: 0.5rem 1rem;
    width: 100%;
    ${Constants.InputBorderBottom}
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    height: 52px;
  }
`;
const Content = styled.div`
  inset: 0;
  margin: auto;
  display: flex;
  flex-direction: column;
  padding-bottom: 4rem;
  min-height: 100%;
`;
const tabs = [
  { name: 'collections', value: 'Collections' },
  { name: 'users', value: 'Users' }
];

export default class LogicBaseSearchBar extends LogictryComponent {
  state = {
    showing: '',
    initialInputFocus: false
  }
  constructor() {
    super();
    this.innerHeight = window.innerHeight;
  }
  componentDidMount() {
    WindowSize.onStateUpdate(this);
    LogicBaseCollectionCache.onStateUpdate(this);
    UserCache.onStateUpdate(this);
  }
  componentWillUnmount() {
    WindowSize.offStateUpdate(this);
    LogicBaseCollectionCache.offStateUpdate(this);
    UserCache.offStateUpdate(this);
    clearTimeout(this.__searchTimeout);
  }
  onKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      if (this.__input) this.__input.blur();
      this.runSearch();
    } else {
      clearTimeout(this.__searchTimeout);
      this.__searchTimeout = setTimeout(() => {
        this.runSearch();
      }, 500);
    }
  }
  runSearch = () => {
    const search = this.__input.value.trim();
    this.setState({ search });
  }
  render() {
    const { mobile } = WindowSize;
    const { search, showing } = this.state;
    if (showing === 'collections') {
      this.showCollections = search && LogicBaseCollectionCache.query({ search }) || this.showCollections;
    } else if (showing === 'users') {
      const usersSearched = search && UserCache.getUsers({
        page: 1,
        search,
      });
      this.showUsers = usersSearched && {
        search: true,
        users: usersSearched
      } || this.showUsers;
    }
    return <>
      <Search
        onClick={() => this.setState({ initialInputFocus: false, showing: (['users', 'account'].includes(Navigation.currentLocation[1]) || Navigation.currentLocation[1].startsWith('@')) ? 'users' : 'collections' })}
      >
        {!mobile && <div
          style={{ padding: `10px 0 10px 1rem` }}
        >
          Search
        </div> || <div></div>}
        <SearchIcon
          style={{ width: mobile ? 22 : 20, height: mobile ? 22 : 20, opacity: mobile ? 1 : 0.3, margin: !mobile && '10px 16px' }}
        />
      </Search>
      {showing && <Popup
        showCloseButton
        allowBackgroundClose
        onClose={() => {
          this.showCollections = null;
          this.showUsers = null;
          this.setState({ showing: '', search: '' });
        }}
      >
        <Wrapper
          style={{ height: Constants.isIphone && `calc(${this.innerHeight}px - 6rem)` }}
        >
          <input
            ref={(e) => {
              const { initialInputFocus } = this.state;
              if (!e) return;
              this.__input = e;
              if (initialInputFocus) return;
              this.state.initialInputFocus = true;
              e.focus();
            }}
            style={{
              padding: `10px 3rem 10px 1rem`
            }}
            enterKeyHint="search"
            onKeyDown={this.onKeyDown}
            placeholder="Search"
          ></input>
          <Scrollable
            vertical
            style={{ position: 'absolute', top: 52, right: 0, bottom: 0, left: 0, padding: mobile ? '2rem 1rem' : '2rem' }}
            adjustForScrollbar
            onScroll={() => { if (this.__input) this.__input.blur(); }}
          >
            <LogicBaseTab tabs={tabs} selected={showing} onChange={(showing) => this.setState({ showing })} />
            {showing === 'collections' && <Content style={{ gap: '2rem', paddingTop: '1rem' }}>
              {this.showCollections && this.showCollections.map((collection) => <LogicBaseCollectionRow
                key={collection._id}
                collection={collection}
                disableHoverInformation
              />) || search && <div style={{ margin: '2rem auto' }}><LoadingIndicator /></div>}
            </Content>}
            {showing === 'users' && <Content style={{ gap: '1rem', paddingTop: '2rem' }}>
              {this.showUsers && this.showUsers.users.filter((user) => !user.error).map((user) => (
                <div key={user._id}>
                  <UserProfileHeader
                    user={user}
                    large
                  />
                </div>
              )) || search && <div style={{ margin: '2rem auto' }}><LoadingIndicator /></div>}
            </Content>}
          </Scrollable>
        </Wrapper>
      </Popup>}
    </>
  }
}
